module.exports = __webpack_public_path__ + "static/weremember-logo-c113dcb801f569afb12426f83d64edd5.svg";